import axios from "axios";
import {TankCheck} from "./postTankCheckList";
import {BaseResponse} from "../../BaseResponse";

export async function getTankCheck(uid: string) {
    const response = await axios.get<BaseResponse<TankCheck>>(`/tank/check/${uid}`)

    return response.data
}